import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Brain, Wind, Home } from 'lucide-react';
import { motion } from 'framer-motion';
const BOOK_COVER = 'https://cdn.magicpatterns.com/uploads/116EEuHnFcXbicz3box3HL/ChatGPT_Image_Mar_29,_2026,_05_17_27_PM.png';
export function ProductIntro() {
  return <section className="w-full bg-night-950 text-white py-16 md:py-24 px-6 relative overflow-hidden" data-id="element-324">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-purple-900/10 rounded-full blur-[100px] pointer-events-none" data-id="element-325" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-326">
        <FadeIn data-id="element-327">
          <div className="text-center mb-12 md:mb-16" data-id="element-328">
            <span className="text-purple-400 font-medium tracking-wider uppercase text-xs md:text-sm mb-3 md:mb-4 block" data-id="element-329">
              Presentando
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-medium mb-4 md:mb-6" data-id="element-330">
              Mente en Calma
            </h2>
            <p className="text-lg md:text-2xl text-purple-100/80 font-light max-w-3xl mx-auto" data-id="element-331">
              El método de 7 noches para apagar la ansiedad nocturna y volver a
              dormir profundo.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-10 md:gap-12 items-center mb-12 md:mb-16" data-id="element-332">
          {/* Book cover */}
          <FadeIn delay={0.1} data-id="element-333">
            <div className="flex justify-center" data-id="element-334">
              <motion.div className="relative" whileHover={{
              scale: 1.02,
              rotate: 1
            }} transition={{
              duration: 0.4
            }} data-id="element-335">
                <div className="absolute -inset-6 bg-purple-500/10 rounded-full blur-[40px] pointer-events-none" data-id="element-336" />
                <img src={BOOK_COVER} alt="Mente en Calma — Guía de 36 páginas" className="relative w-56 md:w-72 rounded-2xl" style={{
                WebkitMaskImage: 'radial-gradient(ellipse 85% 85% at center, black 75%, transparent 100%)',
                maskImage: 'radial-gradient(ellipse 85% 85% at center, black 75%, transparent 100%)'
              }} data-id="element-337" />
              </motion.div>
            </div>
          </FadeIn>

          {/* Three layers */}
          <FadeIn delay={0.2} data-id="element-338">
            <h3 className="text-xl md:text-2xl font-serif mb-6 md:mb-8 text-center md:text-left" data-id="element-339">
              Es un método estructurado que trabaja en tres capas al mismo
              tiempo:
            </h3>

            <div className="space-y-3 md:space-y-4" data-id="element-340">
              {[{
              icon: Brain,
              title: 'Mente',
              desc: 'Vaciado mental, cierre del día, bucles de pensamiento'
            }, {
              icon: Wind,
              title: 'Cuerpo',
              desc: 'Respiración, activación del sistema nervioso, cortisol nocturno'
            }, {
              icon: Home,
              title: 'Entorno',
              desc: 'Luz, temperatura, señales de sueño, rutina de cierre'
            }].map((layer, i) => <div key={i} className="flex items-start p-3 md:p-4 rounded-xl bg-white/5 border border-white/5" data-id="element-341">
                  <div className="p-2 md:p-3 bg-purple-500/20 rounded-lg mr-3 md:mr-4" data-id="element-342">
                    <layer.icon className="w-5 h-5 md:w-6 md:h-6 text-purple-300" data-id="element-343" />
                  </div>
                  <div data-id="element-344">
                    <h4 className="text-base md:text-lg font-medium text-white mb-1" data-id="element-345">
                      {layer.title}
                    </h4>
                    <p className="text-sm md:text-base text-slate-400" data-id="element-346">
                      {layer.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.25} data-id="element-347">
          <div className="text-center mb-10 md:mb-12" data-id="element-348">
            <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 backdrop-blur-sm max-w-2xl mx-auto" data-id="element-349">
              <p className="text-base md:text-lg text-slate-300 leading-relaxed mb-4" data-id="element-350">
                Mente en Calma es una guía práctica con un protocolo progresivo,
                noche por noche, para que en una semana tengas instalado un
                sistema de descanso real.
              </p>
              <p className="text-base md:text-lg text-slate-300 leading-relaxed" data-id="element-351">
                No es un libro de autoayuda. No es una lista de tips que ya
                conoces.
              </p>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-352">
          <div className="text-center" data-id="element-353">
            <p className="text-xl md:text-2xl font-serif text-purple-200 italic px-4" data-id="element-354">
              "Porque si solo trabajas una parte, el sistema sigue roto."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}